<template>
  <div id="awards" class="white--text">
      <v-container>

        <span v-if="language==='RU'"><PageTitle :title="title_RU" class="mt-4" /></span>
        <span v-if="language==='EN'"><PageTitle :title="title_EN" class="mt-4" /></span>

          <v-layout row wrap align-center justify-center fill-height class="mt-4">
              <v-flex xs12 sm8 class="white--text">
                  <span v-if="language==='RU'"><div v-html="content_RU"></div></span>
                  <span v-if="language==='EN'"><div v-html="content_EN"></div></span>
              </v-flex>
          </v-layout>        
      </v-container>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle'
  export default {
    name: 'Awards',
    components: { PageTitle },
    data() {
      return {
        language: '',
        title_RU: 'Награды и заслуги',
        title_EN: 'Awards',
        content_RU: '<ul><li>Лауреат Международного конкурса молодых вокалистов им. А. Соловьяненко "Соловьиная ярмарка" (2004 год)</li><li>Лучший работник культуры года (2005 год)</li><li>Дипломант Международного конкурса оперных певцов в Италии, 2008 год</li><li>В январе 2013 года за значительный вклад в культурно-просветительское развитие Украины, существенные творческие достижения и многолетнюю плодотворную деятельность Анне Братусь присвоено звание Заслуженной артистки Украины.</li></ul>',
        content_EN: '<ul><li>Winner of the International Competition for Young Singers in A. Solovyanenko name  "Nightingale\'s Fair" (2004)</li><li>The best worker ogf the national culture (2005)</li><li>Diploma of the International Opera Competition in Italy in 2008.</li><li>In January 2013 for the valuable contribution into the culture and education in Ukraine for significant professional achievements and for the continious and fruitful performance Anna Bratus was awarded the title of "Honored artist of Ukraine".</li></ul>'
      }
    },
    mounted(){
      if(localStorage.lang){
        this.language = localStorage.lang
      }
    }
  }
</script>


